import type { RefObject } from 'react';
import { useDebouncedValue } from 'app/lib/hooks/useDebouncedValue/useDebouncedValue';
import { useResizeObserver } from 'app/lib/hooks/useResizeObserver/useResizeObserver';
import type { Dimensions } from 'app/lib/types/ui';

export function useDebouncedDimensions(
    ref: RefObject<HTMLElement>,
    delay: number = 500
): Dimensions {
    const { width: observedWidth, height: observedHeight } = useResizeObserver(ref);
    const width = useDebouncedValue(observedWidth, delay);
    const height = useDebouncedValue(observedHeight, delay);
    return { width, height };
}
